import * as React from "react";

import {BufferForm}                       from "@Common/logic/checkout/common/buffer-form";
import {cs}                               from "@Common/react/chain-services";
import {consumeContext}                   from "@Common/react/context";
import {keyed}                            from "@Common/react/keyed";
import {cascade, cascadeFind, cascadeSum} from "@Common/utils/cascade";
import {unique}                           from "@Common/utils/collections";

import {Line} from "../common/line";

import {removeStoreCredits} from "./remove-store-credits";
import {setStoreCredits}    from "./set-store-credits";

export const StoreCreditSection = ({store, next}) => cs(
    consumeContext("apis"),
    ({apis}) => {
        const storeCredits = unique(cascade(store.cart.items, "[*].billingAvailable.storecredit[*].id"));
        return next({
            available: !!storeCredits.length,
            render: () => storeCredits.map((scId) => {

                const rawSelected = cascadeFind(store.cart, "appliedCredits.storeCredits[*].id", (id) => id === scId);

                const storeCredits = cascadeFind(store.cart.items, `[*].billingAvailable.storecredit[*]`, (sc) =>
                    sc.id === scId && sc
                );
                const apiError = store.cart.paymentErrors?.storeCredits?.find((sc) => sc.storeCredit === scId)?.error;
                return cs(
                    keyed(scId),

                    ["selected", ({}, next) => BufferForm({
                        value: rawSelected,
                        disableBuffer: !store.saving,
                        applyChange: (value) => store.dispatch(
                            (value ? setStoreCredits : removeStoreCredits)(scId, {apis})
                        ),
                        next,
                    })],
                    ({selected}) => (
                        Line({
                            selected,
                            label: "Store Credit",
                            avaiAmount : storeCredits.amountAvailable,
                            appliedAmount: rawSelected && cascadeSum(store.cart, `appliedCredits.storeCredits[*]`, (sc) => sc.id == scId ? sc.amount : 0),
                            apiError,
                            storeCreditDesc : storeCredits.desc
                        })
                    )
                );
            }),
        });
    },
);
